import type { FC } from 'react';

import { quantity } from '@/care/returns/components/ProductCard/translations';
import { Image } from '@/core/Image/Image';
import { isB2C } from '@/core/settings/utils';
import { DetailedPrice as TamagoshiDetailedPrice } from '@/core/tamagoshi/DetailedPrice/DetailedPrice';
import { Typography } from '@/core/tamagoshiv2/components/Typography/Typography';
import { AddToCartErrorLabel } from '@/domains/productDiscovery/ProductPage/common/components/AddToCart/AddToCartErrorLabel';
import type {
  Error,
  Product,
} from '@/shoppingCart/AddToCart/AddToCart.interfaces';
import { mapCurrency } from '@/shoppingCart/AddToCart/utils/mapCurrency';
import {
  allTaxExcludedShort,
  allTaxIncludedShort,
} from '@/shoppingCart/CartPage/components/ProductCard/ProductPrices/translations';

import styles from './addToCartModal.module.scss';

interface Props {
  product: Product;
  error?: Error;
}

export const AddToCartModalProduct: FC<Props> = ({ product, error }) => (
  <div className={styles.productGrid}>
    <Image
      alt="product-summary-thumbnail"
      src={product?.picture}
      height="80"
      width="80"
      className={styles.thumbnail}
    />
    <Typography type="semiBold" variant="body2" className={styles.title}>
      {product?.name}
    </Typography>
    {error && <AddToCartErrorLabel error={error} />}
    <Typography variant="body2" className={styles.quantity}>
      {`${quantity} ${product.quantity || 1}`}
    </Typography>
    <div className={styles.price}>
      {product.prices?.main && (
        <TamagoshiDetailedPrice
          className={styles.container}
          value={product.prices.main}
          retailValue={product.prices?.retail ?? undefined}
          secondaryValue={product.prices?.secondary ?? undefined}
          retailAbove
          currency={mapCurrency(product?.currency || 'EUR')}
          tax={isB2C() ? 'VAT' : 'withoutVAT'}
          translations={{
            price: {
              withoutVAT: allTaxExcludedShort,
              VAT: allTaxIncludedShort,
            },
          }}
        />
      )}
    </div>
  </div>
);
